import { useState, useEffect } from 'react';
import { getBuyerId } from 'dibs-cookie-jar';
import { addLoginHandlers } from 'dibs-buyer-layout/exports/loginHandlers';

export function useLoggedInUser(): string | null {
    const [userId, setUserId] = useState<string | null>(null);

    useEffect(() => {
        setUserId(getBuyerId(document.cookie));

        addLoginHandlers(() => {
            setUserId(getBuyerId(document.cookie));
        });
    }, []);

    return userId;
}
